import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import * as AOS from 'aos';
import { HeaderComponent } from '../components/header.component';
import { HeroComponent } from '../components/hero.component';
import { ProblemComponent } from '../components/problem.component';
import { ModelComponent } from '../components/model.component';
import { FeaturesComponent } from '../components/features.component';
import { ComparisonComponent } from '../components/comparison.component';
import { AfricaComponent } from '../components/africa.component';
import { PricingComponent } from '../components/pricing.component';
import { CtaComponent } from '../components/cta.component';
import { FooterComponent } from '../components/footer.component';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    HeroComponent,
    ProblemComponent,
    ModelComponent,
    FeaturesComponent,
    ComparisonComponent,
    AfricaComponent,
    PricingComponent,
    CtaComponent,
    FooterComponent
  ],
  template: `
    <div class="min-h-screen flex flex-col font-satoshi text-gray-450 bg-dark-100 selection:bg-primary/30 selection:text-white overflow-x-hidden overflow-y-auto w-full relative">
      <app-header></app-header>
      <main class="flex-grow w-full relative overflow-x-hidden">
        <app-hero></app-hero>
        <app-problem></app-problem>
        <app-model></app-model>
        <app-features></app-features>
        <app-comparison></app-comparison>
        <app-africa></app-africa>
        <app-pricing></app-pricing>
        <app-cta></app-cta>
      </main>
      <app-footer></app-footer>
    </div>
  `
})
export class HomeComponent implements OnInit {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      AOS.init({
        once: true,
        duration: 800,
        offset: 50,
        easing: 'ease-out-cubic'
      });
    }
  }
}
